// Supabase client for global data tracking
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = (import.meta.env.VITE_SUPABASE_URL as string) || '';
const supabaseAnonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY as string) || '';

let _supabase: ReturnType<typeof createClient> | null = null;
if (supabaseUrl && supabaseAnonKey) {
  try {
    _supabase = createClient(supabaseUrl, supabaseAnonKey);
  } catch (e) {
    console.warn('[Supabase] Failed to create client:', e);
  }
}
export const supabase = _supabase;

// Log Supabase initialization status
if (typeof window !== 'undefined') {
  if (supabase && supabaseUrl && supabaseAnonKey) {
    console.log('[Supabase] ✓ Client initialized successfully');
    console.log('[Supabase] URL:', supabaseUrl);
  } else {
    console.warn('[Supabase] ⚠ Client not initialized - missing credentials');
  }
}

// Check if Supabase is configured
export const isSupabaseConfigured = (): boolean => {
  const isConfigured = !!supabaseUrl && !!supabaseAnonKey && !!supabase;
  
  if (!isConfigured && typeof window !== 'undefined') {
    if (!supabaseUrl || !supabaseAnonKey) {
      console.warn('[Supabase] Supabase is not configured. Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY environment variables.');
    }
  }
  
  return isConfigured;
};

// Test Supabase connectivity (verifies connection and table access)
export const testSupabaseConnection = async (): Promise<boolean> => {
  if (!isSupabaseConfigured() || !supabase) {
    console.warn('[Supabase] Connection test skipped - Supabase not configured');
    return false;
  }

  try {
    console.log('[Supabase] Testing connection...');
    
    // Test 1: Simple query to verify connection
    const { data, error } = await supabase
      .from('site_stats')
      .select('id, total_visits')
      .eq('id', 'global')
      .limit(1);
    
    if (error) {
      if (error.code === 'PGRST116') {
        // Row not found - table exists but no data yet (this is OK)
        console.log('[Supabase] ✓ Connection successful - table exists but no data yet');
        return true;
      } else if (error.code === 'PGRST301') {
        console.error('[Supabase] ✗ Connection test failed: Permission denied. Check RLS policies.');
        return false;
      } else {
        console.error('[Supabase] ✗ Connection test failed:', error.code, error.message);
        return false;
      }
    }
    
    console.log('[Supabase] ✓ Connection test successful');
    if (data && data.length > 0) {
      console.log('[Supabase] Current visit count:', data[0].total_visits);
    }
    return true;
  } catch (error: any) {
    console.error('[Supabase] ✗ Connection test error:', error.message);
    return false;
  }
};
